import { request } from '@/utils';
import { useQuery } from 'react-query';
import { useCurrentAddressInfo } from './address';

type TrialOperateType =
  | 'POST'
  | 'REPOST'
  | 'COMMENT'
  | 'TRUST_POST'
  | 'DISTRUST_POST'
  | 'TRUST_COMMENT'
  | 'DISTRUST_COMMENT'
  | 'JOIN_LUCKY_DRAW'
  | 'FOLLOW_USER'
  | 'FOLLOW_OFFICIAL';

type TrialFeatureRes = {
  is_active: boolean;
  reason: string;
};

export const useUserTrial = (operate_type: TrialOperateType) => {
  const { address: currentAddress } = useCurrentAddressInfo();
  return useQuery(['/user/check_trail_feature', currentAddress, operate_type], () =>
    request.post<TrialFeatureRes>('/user/check_trail_feature', {
      feature: operate_type,
    }),
  );
};
